module.exports = __webpack_public_path__ + "img/anewitem-phones.2002c350.svg";